// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@stoneage/Overrides/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";
import { color, layoutContainer, xScreen } from "@stoneage/XDL/Utilities";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { src: Search },
};

searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
            max-width: 100vw;
            &:empty {
                border: none;
            }
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

searchInputStyles.fancyScrollCategories = {
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
        }
    `,
};

searchInputStyles.fancyScrollProducts = {
    css: css`
        ${xScreen("lte", "sm")} {
            order: 1;
        }
    `,
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        padding: 12px;
        display: grid;
        grid-template-columns: 1fr;
        gap: 24px;

        &.show-divider {
            &:before {
                content: "";
                height: 100%;
                width: 1px;
                position: absolute;
                left: 100%;
                top: 0;
                bottom: 0;
                background: ${color("common.ui6")};
            }
        }

        &:empty {
            padding: 0;
            &:before {
                display: none;
            }
        }

        ${xScreen("lte", "sm")} {
            &:before {
                display: none;
            }
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 12px;
        &:empty {
            padding: 0;
        }
    `,
};

searchInputStyles.mobileOverlayTopBar = {
    css: css`
        position: fixed;
        left: 0;
        right: 0;
        z-index: 9999;
        background: white;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 5px 0;
        background: ${color("common.ui4")};
        ${layoutContainer}
    `,
};

searchInputStyles.mobileOverlayResults = {
    css: css`
        position: fixed;
        left: 0;
        right: 0;
        top: 56px;
        bottom: 0;
        z-index: 9999;
        overflow-y: auto;
    `,
};
